import React from "react";
import { TopBar } from "./TopBar";
import { Footer } from "./Footer";

export function Layout({ children }: { children: React.ReactNode }) {
	return (
		<div className="min-h-full">
			<header className="bg-white shadow-sm">
				<TopBar />
			</header>

			<div className="max-w-6xl mx-auto px-6">
				<main>
					{/* <ProjectSelector /> */}
					<div className="mx-auto">
						{children}
					</div>
				</main>
			</div>

			<Footer />
		</div>
	);
}
